import { NgModule } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SharedNavigationNavModule } from '@reconcept-platform/shared/navigation/nav';
import { ListGroupExpandParentDirective } from './list-group-expand-parent.directive';
import { ListGroupExpandableComponent } from './list-group-expandable.component';

@NgModule({
  declarations: [ListGroupExpandableComponent, ListGroupExpandParentDirective],
  imports: [RouterLink, RouterLinkActive, FaIconComponent, SharedNavigationNavModule],
  exports: [ListGroupExpandableComponent, ListGroupExpandParentDirective],
})
export class ListGroupExpandableModule {
  /**
   * ListGroupExpandableModule is required because ListGroupExpandableComponent uses ListGroupExpandParentDirective
   * and vice versa. This is a circular dependency.
   * In standalone components this causes an issue in production builds only.
   */
}
